import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const RecieptsSectionContainer = styled(Grid)({
  minWidth: "600px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

export const HeaderBlock = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-end",
});

export const RecieptTableContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  height: "100%",
});

export const RecieptsContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "diffHeight" && prop !== "customTableHeight" && prop !== "noItems",
})<{ diffHeight?: number; customTableHeight?: boolean; noItems?: boolean }>(
  ({ theme }) => ({
    width: "100%",
    minWidth: "400px",
    height: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  }),
  ({ diffHeight }) => ({
    ...(!!diffHeight && {
      height: `calc(65vh - ${diffHeight + 35}px)`,
    }),
  }),
  ({ diffHeight, customTableHeight }) => ({
    ...(!!diffHeight &&
      !!customTableHeight && {
        height: `calc(100% - ${diffHeight + 35}px)`,
      }),
  }),
  ({ noItems }) => ({
    ...(!!noItems && {
      alignItems: "center",
      justifyContent: "center",
    }),
  })
);
